import { categories } from "@/mocks/homeData";

const gridCategories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    accent: "bg-accent-100",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20pair%20of%20designer%20sneakers%20on%20pristine%20white%20marble%20surface%20with%20soft%20natural%20lighting%20minimalist%20editorial%20product%20photography%20warm%20beige%20background%20clean%20shadow%20high%20detail%20fashion%20aesthetic&width=600&height=800&seq=cat-shoes-v2&orientation=portrait",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    accent: "bg-secondary-100",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxurious%20oversized%20hoodie%20draped%20over%20wooden%20hanger%20against%20warm%20cream%20textured%20wall%20soft%20diffused%20natural%20light%20editorial%20fashion%20photography%20cozy%20aesthetic%20high%20detail%20subtle%20fabric%20texture&width=600&height=800&seq=cat-hoodies-v2&orientation=portrait",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    accent: "bg-background-100",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20t-shirt%20neatly%20folded%20on%20light%20oak%20wooden%20surface%20with%20gentle%20morning%20sunlight%20minimalist%20catalog%20product%20photography%20warm%20neutral%20tones%20clean%20composition&width=600&height=800&seq=cat-tshirts-v2&orientation=portrait",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    accent: "bg-accent-50",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20displayed%20on%20minimal%20wooden%20mannequin%20against%20warm%20ivory%20backdrop%20soft%20studio%20lighting%20editorial%20fashion%20photography%20clean%20elegant%20aesthetic%20high%20detail%20texture&width=600&height=800&seq=cat-jackets-v2&orientation=portrait",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    accent: "bg-secondary-50",
    imageUrl: "https://readdy.ai/api/search-image?query=Well-tailored%20casual%20trousers%20laid%20flat%20on%20light%20linen%20fabric%20surface%20soft%20natural%20window%20light%20minimal%20product%20photography%20warm%20sand%20tones%20editorial%20catalog%20style%20clean%20folds&width=600&height=800&seq=cat-pants-v2&orientation=portrait",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    accent: "bg-background-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20resting%20on%20smooth%20concrete%20surface%20with%20warm%20golden%20hour%20lighting%20minimalist%20streetwear%20product%20photography%20cream%20background%20editorial%20aesthetic%20clean%20shadows&width=600&height=800&seq=cat-headwear-v2&orientation=portrait",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    accent: "bg-accent-100/70",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20casual%20set%20beautifully%20arranged%20on%20light%20wooden%20surface%20with%20soft%20diffused%20natural%20lighting%20minimalist%20fashion%20product%20photography%20warm%20neutral%20background%20editorial%20style&width=600&height=800&seq=cat-sets-v2&orientation=portrait",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    accent: "bg-secondary-100/70",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20draped%20elegantly%20on%20minimal%20display%20stand%20against%20warm%20cream%20studio%20backdrop%20soft%20lighting%20clean%20product%20photography%20editorial%20aesthetic%20fabric%20detail&width=600&height=800&seq=cat-jersey-v2&orientation=portrait",
  },
];

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3 block">
            Shop by Category
          </span>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 leading-tight">
            <span className="font-bold">Browse</span>
            <br />
            <span className="italic font-normal">All Categories</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {gridCategories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group block rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${cat.accent}`}
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`OOPBuy Spreadsheet ${cat.name} category`}
                  title={`Browse ${cat.name} with OOPBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 bg-white/80">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 text-center">
                  {cat.name}
                </h3>
              </div>
            </a>
          ))}
        </div>

        {categories.length > 8 && (
          <div className="mt-8 text-center">
            <span className="text-sm text-foreground-500">
              +{categories.length - 8} more categories available in the dropdown menu above
            </span>
          </div>
        )}
      </div>
    </section>
  );
}